import {Link} from "react-router";

import Button from "@/components/button/Button.tsx";

export const CTAManageSubscription = () => (
  <div className="d-flex align-items-center h-100">
    <Button as={Link} to="/billing/manage-subscription">
      Manage Subscription
    </Button>
  </div>
);
